import { render, staticRenderFns } from "./image-view.vue?vue&type=template&id=274fd7f2&"
import script from "./image-view.vue?vue&type=script&lang=js&"
export * from "./image-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports